// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const mainHeaderHeight = 88;
export const horizontalHeaderHeight = 84;
export const horizontalBarHeight = 62;
